export default __webpack_public_path__ + "static/media/inactive-dashboard.92bc1e4a.svg";